import BookIndex from "components/shared/book/list";
import { Transition } from "components/shared/column";
import SharedReactTable from "components/shared/reactTable";
import { RecipientWithOrgOption, RecipientWithOrgValueContainer } from "components/shared/select";
import { dateTimeToView } from "helpers/date";
import { paths } from "helpers/paths";
import { DateRangeColumnFilter, SelectColumnFilter } from "helpers/reactTable";
import { tableContainer } from "helpers/redux";
import policy from "policies";
import React from "react";
import { Link } from "react-router-dom";
import { deleteBlockedEmail, getAllUsersForSelectList, getOrganizationNames } from "sources/admin";

class BlockedEmails extends BookIndex {
    componentWillUnmount() {
        this.props.clearParams();
    }

    get tableColumns() {
        return [
            { Header: "ID", accessor: "id", width: 100, filterable: true, filterType: "int" },
            { Header: "Эл. почта", accessor: "email", filterable: true },
            { Header: "Ошибка", accessor: "error", filterable: true },
            {
                Header: "Пользователь",
                accessor: "userName",
                id: "userId",
                sortable: true,
                filterable: true,
                filterType: "select",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            url: getAllUsersForSelectList,
                            inputProps: { name: "fullNameOrEmail" },
                            propName: "fullNameOrEmail",
                            components: {
                                Option: RecipientWithOrgOption,
                                ValueContainer: RecipientWithOrgValueContainer,
                            },
                        }}
                    />
                ),
            },
            {
                Header: "Организация",
                accessor: "organizationName",
                id: "organizationId",
                sortable: true,
                filterable: true,
                filterType: "select",
                Filter: (props) => (
                    <SelectColumnFilter
                        {...props}
                        selectProps={{
                            url: getOrganizationNames,
                            inputProps: { name: "organizationId" },
                            propName: "name",
                        }}
                    />
                ),
                Cell: ({
                    row: {
                        original: { organizationName, organizationId },
                    },
                }) =>
                    organizationName &&
                    organizationId && <Link to={paths.adminOrganizationsShow(organizationId)}>{organizationName}</Link>,
            },
            {
                Header: "Дата блокировки",
                accessor: "blockedAt",
                filterable: true,
                Filter: DateRangeColumnFilter,
                filterType: "dateTimeRange",
                Cell: ({ value }) => dateTimeToView(value, "DD.MM.YYYY HH:mm:ss"),
            },
            {
                Header: "Действие",
                width: 190,
                notExportable: true,
                id: "action",
                sortable: false,
                Cell: ({ row }) => this.actions(row.original),
            },
        ];
    }

    actions = (data) => {
        const { roles } = this.props;
        return (
            policy("user", { user: { roles } }).isAdminWithWriteAccess() && (
                <div className="btn btn-xs btn-outline-primary" onClick={this.deleteItem.bind(this, data)}>
                    Разблокировать
                </div>
            )
        );
    };

    deleteItem = (data) => {
        const { modal, mergeParams } = this.props;
        return modal({
            name: "confirm",
            title: "Разблокировка",
            text: "Вы уверены, что хотите разблокировать электронную почту?",
            buttons: { confirm: "Разблокировать", cancel: "Отменить" },
            action: () => deleteBlockedEmail({ id: data.id }).then(() => mergeParams({})),
        });
    };

    renderHead = () => {
        return (
            <div className="book-list__head">
                <div className="book-list__head-close close close--sm" onClick={this.close} />
                <div className="book-list__head-title">Заблокированные электронные адреса</div>
                <div className="btn-toolbar" />
            </div>
        );
    };

    renderListComponent = () => {
        return <SharedReactTable {...this.props} columns={this.state.tableColumns} />;
    };

    render() {
        return (
            <div className="page-content">
                <Transition dir="full">
                    <div className="page-book__list book-list list book-list--nofilter">
                        {this.renderHead()}
                        <div className="container-fluid my-2">{this.renderActions()}</div>
                        {this.renderListComponent()}
                    </div>
                </Transition>
            </div>
        );
    }
}

export default tableContainer(BlockedEmails, "blocked-emails");
